module.exports = __webpack_public_path__ + "img/f2-02.d85d36a9.png";